import { BehaviorSubject } from 'rxjs'
export default new BehaviorSubject<any>(null)
